import request from "@/utils/request";

export function changePassword(data) {
  return request({
    url: "/user/change-password",
    method: "post",
    data
  });
}
